import { Icon } from '../../components/icons/Icon'
import { Popover } from './Popover'
import type { ExportFormat } from './types'

export interface ExportMenuProps {
  onExport: (format: ExportFormat) => void
  open: boolean
  onOpenChange: (open: boolean) => void
  label?: string
  /**
   * Reporting & Exports honesty rule (CLAUDE.md): export exactly what's loaded/shown; when a list
   * is paginated/capped, say so right where the export action lives — never a silently-partial
   * file. `undefined`/empty renders nothing (the common "everything loaded" case).
   */
  note?: string | undefined
}

const FORMATS: Array<{ id: ExportFormat; label: string }> = [
  { id: 'csv', label: 'CSV' },
  { id: 'xlsx', label: 'XLSX (Excel)' },
  { id: 'pdf', label: 'PDF (print view)' },
]

/** CSV / XLSX / PDF, honoring the current filter, sort, and visible columns. */
export function ExportMenu({ onExport, open, onOpenChange, label = 'Export', note }: ExportMenuProps) {
  return (
    <Popover
      label="Export"
      open={open}
      onOpenChange={onOpenChange}
      width={220}
      align="end"
      triggerContent={
        <>
          <Icon name="download" size={14} /> {label}
        </>
      }
    >
      {note ? (
        <p style={{ margin: '0 0 var(--iw-space-2)', fontSize: 'var(--iw-size-xs)', color: 'var(--iw-text-muted)' }}>
          {note}
        </p>
      ) : null}
      <ul role="menu" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {FORMATS.map((format) => (
          <li key={format.id} role="none">
            <button
              type="button"
              role="menuitem"
              className="iw-btn iw-btn--ghost iw-btn--sm"
              style={{ width: '100%', justifyContent: 'flex-start' }}
              onClick={() => {
                onExport(format.id)
                onOpenChange(false)
              }}
            >
              {format.label}
            </button>
          </li>
        ))}
      </ul>
    </Popover>
  )
}
